import { useState } from "react";
import { CirclePlay, Image as ImageIcon } from "lucide-react";
import { mediaUrl } from "@/lib/api";

const Thumb = ({ att, onClick, testId }) => {
  const [failed, setFailed] = useState(false);
  const isVideo = att.mime.startsWith("video/");
  return (
    <button
      type="button"
      onClick={onClick}
      title={att.filename}
      data-testid={testId}
      className="relative h-12 w-12 shrink-0 overflow-hidden rounded-lg border border-slate-200 bg-slate-100 transition-transform duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-emerald-500"
    >
      {isVideo ? (
        <span className="flex h-full w-full items-center justify-center bg-slate-900 text-white"><CirclePlay className="h-5 w-5" /></span>
      ) : failed ? (
        <span className="flex h-full w-full items-center justify-center text-slate-400"><ImageIcon className="h-5 w-5" /></span>
      ) : (
        <img src={mediaUrl(att.id)} alt={att.filename} loading="lazy" onError={() => setFailed(true)} className="h-full w-full object-cover" />
      )}
    </button>
  );
};

export const MediaThumbs = ({ attachments, onOpen, ownerId }) => {
  if (!attachments?.length) return <span className="text-xs text-slate-400">Tidak ada</span>;
  return (
    <div className="flex gap-1.5">
      {attachments.map((att, i) => (
        <Thumb key={att.id} att={att} onClick={() => onOpen(attachments, i)} testId={`media-thumb-${ownerId}-${i}`} />
      ))}
    </div>
  );
};
